import {
  fetchMentorClass,
  fetchMentorClassStudents,
} from "classroom/api/teacher";
import type { ClassroomMentorClass, ClassroomStudent } from "classroom/types";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useClassroomMentorClassStore = defineStore(
  "classroomMentorClass",
  () => {
    const mentorClass = ref<ClassroomMentorClass | null>(null);
    const students = ref<ClassroomStudent[] | null>(null);
    const allStudents = ref<ClassroomStudent[] | null>(null);

    const loadMentorClass = async (
      className: string,
      signal?: AbortSignal,
    ): Promise<void> => {
      mentorClass.value = await fetchMentorClass(className, signal);
    };

    const loadStudents = async (
      className: string,
      search: string | null = null,
      signal?: AbortSignal,
    ): Promise<void> => {
      students.value = await fetchMentorClassStudents(
        className,
        search,
        signal,
      );
    };

    // Unfiltered class list for the page header; `students` stays owned by
    // the students tab, which overwrites it with search-filtered results.
    const loadAllStudents = async (
      className: string,
      signal?: AbortSignal,
    ): Promise<void> => {
      allStudents.value = await fetchMentorClassStudents(
        className,
        null,
        signal,
      );
    };

    const reset = (): void => {
      mentorClass.value = null;
      students.value = null;
      allStudents.value = null;
    };

    return {
      mentorClass,
      students,
      allStudents,
      loadMentorClass,
      loadStudents,
      loadAllStudents,
      reset,
    };
  },
);
